import AutoQuestionnaireProcessingProvider from 'components/QuestionnaireRequestAutomated/processor'
import React from 'react'

function QuestionnaireRequestAutomated(props) {
  return (
    <div className="auto-questionnaire-processing-page-wrapper">
      <div className="auto-questionnaire-processing-page-container">
        <div className="dome-d-flex dome-align-start dome-flex-column dome-gap6">
          <a href="/questionnaire_requests/list" className="dome-link dome-link-grey dome-link-chevron-left">
            back to all requests
          </a>
          <div className="dome-d-flex dome-gap6 dome-align-end">
            <h1 style={{ margin: 0 }} className="dome-h2 dome-color-dark-grey">
              questionnaire request
            </h1>
            <span className="dome-p2 dome-color-lite-grey">
              #{props.questionnaire_request?.property_manager_id}-{props.questionnaire_request?.confirmation_id}
            </span>
          </div>
        </div>
        <AutoQuestionnaireProcessingProvider {...props} />
      </div>
    </div>
  )
}

export default QuestionnaireRequestAutomated
